import makeStyles from '@mui/styles/makeStyles';
import { isDark } from 'global/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: theme.breakpoints.values.lg,
    [theme.breakpoints.down('xl')]: {
      width: '90%',
    },
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  icon: {
    margin: theme.spacing(1),
  },
  inlineIcon: {
    color: theme.colors.darkGrey,
    marginBottom: theme.spacing(-0.5),
  },
  performLogo: {
    maxWidth: '249.5px',
  },
  gif: {
    width: '100%',
    maxWidth: '420px',
  },
  performLogoWrapper: {
    width: '100%',
    display: 'flex',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    justifyContent: 'space-around',
  },
  gifWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
  },
  title: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'none',
    fontWeight: 'bold',
    margin: `${theme.spacing(2)} 0`,
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
    },
  },
  flex: {
    display: 'flex',
    margin: 'auto',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  flexLabel: {
    display: 'flex',
    flexWrap: 'none',
    alignItems: 'center',
    color: isDark(theme) ? theme.colors.white : theme.palette.primary.main,
  },
  flexIcons: {
    display: 'flex',
    flexWrap: 'none',
    alignItems: 'center',
    justifyContent: 'center',
  },
  flexTitle: {
    '& h2': {
      display: 'flex',
      flexWrap: 'none',
      alignItems: 'center',
    },
  },
  card: {
    width: '30%',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(4),
    marginLeft: '1.5%',
    marginRight: '1.5%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  sectionHeader: {
    margin: `${theme.spacing(6)} auto`,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  sectionHeaderSubtitle: {
    textAlign: 'left',
  },
  cardAction: {
    height: '100%',
  },
  recentListItem: {
    backgroundColor: 'lightgrey',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    height: theme.spacing(4),
    margin: `${theme.spacing(1)} auto`,
  },
  actionStepper: {
    flexGrow: 1,
  },
  dialogRoot: {
    height: '500px',
    maxHeight: '80vh',
  },
  color: {
    color: theme.palette.primary.main,
    opacity: 'inherit',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
